import classNames from 'classnames';
import DeleteIcon from 'material-ui-icons/Delete';
import IconButton from 'material-ui/IconButton';
import { withStyles } from 'material-ui/styles';
import { lighten } from 'material-ui/styles/colorManipulator';
import Toolbar from 'material-ui/Toolbar';
import Tooltip from 'material-ui/Tooltip';
import Typography from 'material-ui/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import Button from 'material-ui/Button';
import { isEdge } from '../../../services/browserDetector';

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.secondary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: isEdge() ? '1 1 50%' : '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
    paginationControl: {
        border: '1px solid red'
    },
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    }
});

class ReservationsTableToolbar extends React.Component {

    render() {
        const { numSelected, classes, anchorEl, pendingPayments, t } = this.props;
        const isEnabled = pendingPayments.some(p => p.checked);
        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}>
                <div className={classes.title}>
                    {numSelected > 0 ? (
                        <Typography color="inherit" variant="subheading">
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Typography className={classes.tableTitle} >
                            <strong>{t('BOOKINGS.BOOKINGS')}</strong>
                        </Typography>
                    )}
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    {numSelected > 0 ? (
                        <Tooltip title="Delete">
                            <IconButton aria-label="Delete">
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <div>
                        </div>
                    )}
                </div>
                <div style={{ display: 'inherit' }}>
                <div className={classes.actions}>
                        <Button
                            aria-label="COMMON.PAY_RESERVATIONS"
                            variant="raised"
                            aria-owns={anchorEl ? 'download-menu' : null}
                            style={{ minWidth: 180 }}
                            aria-haspopup="true"
                            disabled={!isEnabled}
                            onClick={(event) => {
                                this.props.onPayReservations();
                            }}
                        >
                            {t('COMMON.PAY_RESERVATIONS')}
                        </Button>
                    </div>
                    <div className={classes.spacer} style={{ marginLeft: '10px' }} />
                    <div className={classes.actions}>
                        <Button
                            aria-label="COMMON.EXPORT_AS_PDF"
                            variant="raised"
                            aria-owns={anchorEl ? 'download-menu' : null}
                            style={{ minWidth: 180 }}
                            aria-haspopup="true"
                            onClick={(event) => {
                                this.props.actionHandler('PDF');
                            }}
                        >
                            {t('COMMON.EXPORT_AS_PDF')}
                        </Button>
                    </div>
                    <div className={classes.spacer} style={{ marginLeft: '10px' }} />
                    <div>
                        <Button
                            className={classes.buttonXLS}
                            aria-label="COMMON.EXPORT_AS_XLS"
                            variant="raised"
                            aria-owns={anchorEl ? 'download-menu' : null}
                            style={{ minWidth: 180 }}
                            aria-haspopup="true"
                            onClick={(event) => {
                                this.props.actionHandler('XLS');
                            }}
                        >
                            {t('COMMON.EXPORT_AS_XLS')}
                        </Button>
                    </div>
                </div>
            </Toolbar >
        );
    }
}

ReservationsTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

export default translate('translations')(withStyles(toolbarStyles)(ReservationsTableToolbar));



// WEBPACK FOOTER //
// ./src/components/Reservations/Table/ReservationsTableToolbar.js